module.exports = __webpack_public_path__ + "img/img52.57c2ee23.svg";